import { render, staticRenderFns } from "./OutboundInvestment.vue?vue&type=template&id=243f2e08&scoped=true"
import script from "./OutboundInvestment.vue?vue&type=script&lang=js"
export * from "./OutboundInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243f2e08",
  null
  
)

export default component.exports